// src/components/AdaptiveNotification.jsx
import React, { useState } from "react";
import { updateUserProfile } from "../services/firebase";

export default function AdaptiveNotification({ notification, onDismiss, uid, profile, onAccepted }) {
  const [accepting, setAccepting] = useState(false);
  const { id, type, message, suggested_change } = notification;

  const isOnTrack    = type === "on_track";
  const borderColor  = isOnTrack   ? "border-emerald-500/30"
                     : type === "increase" ? "border-yellow-500/30"
                     : "border-red-500/30";
  const bgColor      = isOnTrack   ? "bg-emerald-950/30"
                     : type === "increase" ? "bg-yellow-950/30"
                     : "bg-red-950/30";
  const icon         = isOnTrack ? "✅" : type === "increase" ? "⬆️" : "⬇️";

  const handleAccept = async () => {
    if (!suggested_change || isOnTrack) return;
    setAccepting(true);
    const newTarget = Math.max(1200, (profile?.calorie_target || 2000) + suggested_change);
    await updateUserProfile(uid, { calorie_target: newTarget });
    await onDismiss(id);
    if (onAccepted) await onAccepted();
    setAccepting(false);
  };

  return (
    <div className={`flex items-start gap-3 border rounded-xl px-4 py-3 ${borderColor} ${bgColor} animate-fade-in`}>
      <span className="text-xl flex-shrink-0">{icon}</span>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-slate-200">{message}</div>
        {!isOnTrack && suggested_change && (
          <div className="text-xs text-slate-500 mt-0.5">
            Suggested adjustment: {suggested_change > 0 ? "+" : ""}{suggested_change} cal/day →{" "}
            new target would be {Math.max(1200, (profile?.calorie_target || 2000) + suggested_change)} cal
          </div>
        )}
        <div className="flex gap-2 mt-2">
          {!isOnTrack && (
            <button onClick={handleAccept} disabled={accepting}
              className="text-xs btn-primary py-1.5 px-3">
              {accepting ? "Applying…" : "Accept Adjustment"}
            </button>
          )}
          <button onClick={() => onDismiss(id)}
            className="text-xs btn-ghost py-1.5 px-3">
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
